import { combineReducers } from "redux";
import { Package } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import {
  CREATE_CONSULT_PACKAGE_REQUEST,
  FETCH_CONSULT_PACKAGE_REQUEST,
  FETCH_CONSULT_PACKAGES_REQUEST,
  UPDATE_CONSULT_PACKAGE_REQUEST,
} from "./constants";
import { Action, PackageState } from "./types";

function packages(state: Package[] = [], action: Action): Package[] {
  switch (action.type) {
    case getSuccessActionType(CREATE_CONSULT_PACKAGE_REQUEST):
      return [...state, action.payload];

    case getSuccessActionType(FETCH_CONSULT_PACKAGES_REQUEST):
      return action.payload;

    case getSuccessActionType(UPDATE_CONSULT_PACKAGE_REQUEST):
      return state.map((packageItem) =>
        packageItem.id === action.data.packageId ? action.payload : packageItem
      );

    default:
      return state;
  }
}

function packageItem(state: PackageState = {}, action: Action): PackageState {
  switch (action.type) {
    case getSuccessActionType(FETCH_CONSULT_PACKAGE_REQUEST):
      return action.payload;

    case getSuccessActionType(UPDATE_CONSULT_PACKAGE_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case CREATE_CONSULT_PACKAGE_REQUEST:
    case FETCH_CONSULT_PACKAGE_REQUEST:
    case FETCH_CONSULT_PACKAGES_REQUEST:
    case UPDATE_CONSULT_PACKAGE_REQUEST:
      return true;

    case getSuccessActionType(CREATE_CONSULT_PACKAGE_REQUEST):
    case getFailureActionType(CREATE_CONSULT_PACKAGE_REQUEST):
    case getSuccessActionType(FETCH_CONSULT_PACKAGE_REQUEST):
    case getFailureActionType(FETCH_CONSULT_PACKAGE_REQUEST):
    case getSuccessActionType(FETCH_CONSULT_PACKAGES_REQUEST):
    case getFailureActionType(FETCH_CONSULT_PACKAGES_REQUEST):
    case getSuccessActionType(UPDATE_CONSULT_PACKAGE_REQUEST):
    case getFailureActionType(UPDATE_CONSULT_PACKAGE_REQUEST):
      return false;

    default:
      return state;
  }
}

export const onlineConsult = combineReducers({ packages, packageItem, isFetching });
